import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { CircleNgIcon, CircleOutlineIcon, TriangleIcon, } from '@/components/ui/SvgIcon/Variable/SvgIconComponents';
import { Text } from '@/components/ui/Typography/Body/Text';
import { IconTextGroup } from '@/components/ui/Typography/IconText/IconTextGroup';
/**
 * セミナー：申し込み期限の状態を表示するコンポーネント
 * @param props
 * @constructor
 */
export const SeminarCliDeadlineIconTextGroup = (props) => {
    const { className, isApplicationDeadlineExceeded, isApplicationDeadlineNear, } = props;
    return (_jsx(IconTextGroup, Object.assign({ className: className }, { children: (() => {
            if (isApplicationDeadlineExceeded) {
                return (_jsxs(_Fragment, { children: [_jsx(CircleNgIcon, { color: 'inactive', size: 'xs' }), _jsx(Text, Object.assign({ color: 'inactive', size: 'sm' }, { children: "\u52DF\u96C6\u7DE0\u5207\u6E08" }))] }));
            }
            if (isApplicationDeadlineNear) {
                return (_jsxs(_Fragment, { children: [_jsx(TriangleIcon, { color: 'secondary', size: 'xs' }), _jsx(Text, Object.assign({ size: 'sm' }, { children: "\u52DF\u96C6\u7DE0\u5207\u9593\u8FD1" }))] }));
            }
            return (_jsxs(_Fragment, { children: [_jsx(CircleOutlineIcon, { color: 'info', size: 'xs' }), _jsx(Text, Object.assign({ size: 'sm' }, { children: "\u53D7\u4ED8\u4E2D" }))] }));
        })() })));
};
